import { createContext, useContext, ReactNode, useMemo } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { createApiClient, ApiService, ApiClientConfig } from '../services/api';
import { queryClient } from '../queryClient'; // Use global instance

interface IApiContext {
	apiClient: ApiService;
	queryClient: typeof queryClient;
}

const ApiContext = createContext<IApiContext | null>(null);

export const useApiService = (): IApiContext => {
	const context = useContext(ApiContext);
	if (!context) {
		throw new Error('useApiService must be used within an ApiProvider');
	}
	return context;
};

interface ApiProviderProps {
	children: ReactNode;
	config: ApiClientConfig;
}

export const ApiProvider = ({ children, config }: ApiProviderProps) => {
	const apiClient = useMemo(() => createApiClient(config), [config]);

	return (
		<QueryClientProvider client={queryClient}>
			<ApiContext.Provider value={{ apiClient, queryClient }}>
				{children}
			</ApiContext.Provider>
		</QueryClientProvider>
	);
};
